import React from 'react';
import Layout from '../components/Layout/Layout';

// Import sports images
import basketball1 from '../images/basketball.jpg';
import basketball2 from '../images/basketball_3.jpg';
import basketball3 from '../images/basketball_4.jpg';
import badminton1 from '../images/badminton.jpg';
import badminton2 from '../images/badminton-competition.jpg';
import kabaddi1 from '../images/kabaddi.jpg';
import kabaddi2 from '../images/kabaddi_1.jpg';
import fencing1 from '../images/fencing.jpg';
import fencing2 from '../images/fencing_1.jpg';
import fencing3 from '../images/fencing_2.jpg';
import fencing4 from '../images/fencing_3.jpg';
import fencing5 from '../images/fencing_medal.jpg';
import wrestling from '../images/wrestling.jpg';

const SportsGalleryPage = () => {
  const images = [
    basketball1, basketball2, badminton1, 
    basketball3, kabaddi1, kabaddi2,
    badminton2, fencing1, fencing2,
    fencing3, fencing5, fencing4,
    wrestling
  ];

  return (
    <Layout>
      <div id="sports-gallery" className="page-container" style={{ backgroundColor: '#fff', minHeight: '100vh', padding: '40px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          
          <div style={{ 
            backgroundColor: '#333', 
            padding: '40px', 
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
          }}>
            <h2 style={{ color: '#90cdf4', borderBottom: '1px solid #555', paddingBottom: '20px', marginBottom: '30px', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'left' }}>
              Sports Gallery
            </h2>

            <div style={{ 
              borderLeft: '5px solid #3182ce', 
              paddingLeft: '20px'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '15px'
              }}>
                {images.map((img, index) => (
                  <div key={index} style={{
                    borderRadius: '4px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                    height: '220px',
                    backgroundColor: '#000'
                  }}>
                    <img 
                      src={img} 
                      alt={`Sports Event ${index + 1}`} 
                      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SportsGalleryPage;
